import script from "./AlertContent.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertContent.vue?vue&type=script&setup=true&lang=js"

import "./AlertContent.vue?vue&type=style&index=0&id=059fc2dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-059fc2dc"]])

export default __exports__